import store from "../store/store";
import router from "../router";
import CapturaService from "./CapturaService";
import LoadScriptFilesService from "./LoadScriptFilesService";
import LivenessService from "./LivenessService";

export default class AppService{

  constructor(props) {
    this.$store = store;
    this.$router = router;
    this.capturaService = new CapturaService();
    this.livenessService = new LivenessService();
  }

  buscarDadosLink(){
    return new Promise(((resolve, reject) => {
      if(this.$store.state.id_link){
        resolve();
        return;
      }
      let k = sessionStorage.getItem('k');
      if(!k){
        reject('Link inválido');
        return;
      }
      k = JSON.parse(atob(k));
      if(!k){
        reject('Dados do link inválidos');
        return;
      }
      this.$store.dispatch('setLoadingStatus',true);
      k.origem = window.location.href;
      this.$store.dispatch('recuperarDadosLinkMeuVivo',k)
          .then(() => {
          this.carregarComponentSelefie(true);
          if(this.$store.getters.tipoCaptura === 1){
            this.carregarComponenteDocumento();
          }
            setTimeout(() =>  resolve(),500);
          })
          .catch(e => reject(e));
    }));
  }

  preLoadSelefie(reload = false){
    this.livenessService.preLoad(reload);
  }

  preLoadDocumento(reload = false){
    let componente_nao_carregado = (typeof window.documento  !== 'object' || !(window.documento instanceof window.BrScanSDKDocumento.Documento));
    if(componente_nao_carregado || reload){
      window.documento = new window.BrScanSDKDocumento.Documento({chave: this.$store.state.chave });
      window.documento.documentosAceitos = ["rg","dni","cnh","cnhcel2022","cnhdig2022"];
      window.documento.documentosLadosAceitos = ["a","b"];
      window.documento.limitarTentativas = false;
      window.documento.preloadModelos(process.env.PATH_FILE_ONNX);
      this.$store.dispatch('definirComponenteDocCarregado',true);
    }
  }

  carregarComponenteDocumento(){
    let loadScript =  new LoadScriptFilesService();
    let date = new Date();
    let id =  btoa(`comp-documento-${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`);
    if(document.getElementById(id)){
      return;
    }
    loadScript.head_script('@/../static/doc/brscan-sdk-documento.min.js?v='+Math.random() * 10,id)
        .then(_ => this.preLoadDocumento())
        .catch(() =>  {
          alert('Falha ao carregar componente de captura de documentos, tente novamente mais tarde.')
          this.$router.replace({name: 'Falha'});
        });
  }

  carregarComponentSelefie(reload = false){
    this.livenessService.carregar(reload).catch(() => {
      alert('Falha ao carregar componente de selfie, tente novamente mais tarde.')
      this.$router.replace({name: 'Falha'});
    })
  }

  logarErro(msg){
    let cpf = this.$store.state.cpf;
    let id_link = this.$store.state.id_link;
    this.capturaService.logarErro(msg,cpf,id_link);
  }

  facesDoc(){
    return ['A','B','AB'];
  }

  tipoDOC(){
    return {
      'cnh': 'CNH',
      'rg': 'RG',
      'outro': 'OUTRO'
    };
  }

  getRouteNameSelfie(){
    return this.livenessService.getRouteName();
  }

  definirTipoDoc(tipoDoc){
    this.$store.dispatch('setTipoDoc',tipoDoc);
    sessionStorage.setItem('tipd',btoa(tipoDoc));
  }


}



// WEBPACK FOOTER //
// ./src/services/AppService.js